import { createAction } from "redux-actions";

export enum Action {
  DELETE_ACCOUNT = "ACCOUNTS_LIST/DELETE_ACCOUNT",
  HANDLE_DELETE_ACCOUNT_SUCCESS = "ACCOUNT/HANDLE_DELETE_ACCOUNT_SUCCESS",
  HANDLE_DELETE_ACCOUNT_FAILURE = "ACCOUNT/HANDLE_DELETE_ACCOUNT_FAILURE",
}

export const deleteAccount = createAction<string>(Action.DELETE_ACCOUNT);
export const handleDeleteAccountSuccess = createAction<void>(Action.HANDLE_DELETE_ACCOUNT_SUCCESS);
export const handleDeleteAccountFailure = createAction<{ message: string }>(Action.HANDLE_DELETE_ACCOUNT_FAILURE);
